import styled, { css } from "styled-components";
import { Colors } from "../../../../../../../../constants";

export const Container = styled.div`
  position: relative;
  min-width: 14.3%;
  max-width: 14.3%;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ isMobile }) =>
    isMobile &&
    css`
      padding: 0 24px;
    `}

  ${({ vertical }) =>
    vertical &&
    css`
      flex-direction: row;
      align-items: start;
    `}
`;

export const IconContainer = styled.div`
  color: var(--light-blue);
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ vertical }) => 
  vertical && 
  css`
    &:after {
      position: absolute;
      content: " ";
      width: 2px;
      background-color: var(--light-blue);
    }

    &:before {
      position: absolute;
      content: " ";
      width: 2px;
      background-color: var(--light-blue);
    }
  `}

  ${({ last }) => 
  last &&
  css`
    &:after {
      min-height: 23px;
      top: 35px;
      height: calc(100% - 32px - 6px);
    }
  `}

  ${({ first }) => 
  first &&
  css`
    &:before {
      top: -6px;
      height: 3px;
    }
  `}

  ${({ grayLine }) =>
  grayLine &&
  css`
    &:after {
      background: ${Colors.SECONDARY_LIGHT_DARK};
    }
    &:before {
      background: ${Colors.SECONDARY_LIGHT_DARK};
    }
  `}
`;

export const StatusName = styled.span`
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: ${Colors.SECONDARY_LIGHT_DARK};
  line-height: 14px;
  margin-bottom: 2px;
  padding: 0 10px;
  
  ${({ vertical }) =>
    vertical &&
  css`
      font-size: 14px;
      text-align: inherit;
      padding: 0;
    `}
`;

export const SubtitleText = styled.span`
  color: var(--light-opacity-gray);
  font-size: 10px;
  line-height: 13px;
  text-align: center;
  letter-spacing: 0.4px;

  ${({ uppercase }) =>
    uppercase &&
    `
    text-transform: uppercase;
  `}

  ${({upperStrong}) =>
    upperStrong &&
    `> strong {
      text-transform: uppercase;
      font-weight: 500;
    }`
  }

  ${({ vertical }) =>
    vertical &&
  css`
      font-size: 14px;
    `}
`;

export const ContainerStatus = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0px;
  white-space: normal;
  align-items: start;
  gap: 4px;

  ${({ vertical }) =>
    vertical &&
    css`
      flex-direction: column;
      align-items: flex-start;
      margin-left: 8px;
      margin-top: 10px;
      margin-bottom: 22px;
      white-space: nowrap;
    `}
`;
